import { COVER_FRAME_CSS, COVER_FRAME_MARKER, COVER_FRAME_WRAPPER_MARKER } from './readium2-styles.js';

/**
 * Fits a cover frame's images to the frame. ReadiumCSS gives the body vertical
 * margins through `--RS__pageGutter`, so a cover sized to the viewport overflows it
 * and clips (FUL-159, https://github.com/readium/readium-css/issues/55).
 *
 * Every image is fitted, since no selector can tell a cover from an ornament across
 * publishers: a wrong guess leaves the real cover clipped by the frame, while fitting
 * an ornament too only costs it some room. COVER_FRAME_CSS sizes what this marks.
 *
 * @param {Document} doc - The iframe document
 */
export const applyCoverFrameStyles = doc => {
    if (!doc?.head) return;

    doc.documentElement?.setAttribute(COVER_FRAME_MARKER, '');

    // Runs before the stylesheet goes in, so an image the publisher hides stays hidden.
    for (const image of doc.querySelectorAll('img, svg')) {
        if (image.getClientRects().length === 0 || image.parentElement?.closest('svg')) continue;
        for (let wrapper = image.parentElement; wrapper && wrapper !== doc.body; wrapper = wrapper.parentElement) {
            wrapper.setAttribute(COVER_FRAME_WRAPPER_MARKER, '');
        }
    }

    const coverStyle = doc.createElement('style');
    coverStyle.setAttribute('type', 'text/css');
    coverStyle.setAttribute('data-volpe-cover-fix', 'true');
    coverStyle.textContent = COVER_FRAME_CSS;
    doc.head.appendChild(coverStyle);
};
